import {
  differenceInDays,
  differenceInMonths,
  differenceInYears,
  format,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
} from "date-fns";

export const GraphColors = [
  "#1D7422",
  "#1B9384",
  "#143373",
  "#5E20A6",
  "#964A20",
  "#8E1F8E",
  "#8E1F4D",
  "#5046E5",
  // -------------
  "#33A539",
  "#6DD2C6",
  "#3354F4",
  "#8D50D4",
  "#E4793D",
  "#C151C1",
  "#CF4780",

  // --------------
  "#79D17E",
  "#BBD9D5",
  "#8FA3FF",
  "#C09EE8",
  "#FFAF82",
  "#CD9BCD",
  "#E19FBB",

  // "#A89FC8",
  // "#FEB09F",
  // "#6DD2C6",
  // "#143373",
  // "#E4793D",
  // "#8D50D4",
  // "#2B39B6",
  // "#68B754",
];

export const getXAxisUnit = (startDate, endDate) => {
  const daysDiff = differenceInDays(endDate, startDate);
  const monthsDiff = differenceInMonths(endDate, startDate);
  const yearsDiff = differenceInYears(endDate, startDate);

  if (yearsDiff >= 1) return "quarter";
  else if (monthsDiff >= 3) return "month";
  else if (monthsDiff >= 1) return "week";
  else if (daysDiff >= 15) return "week";
  else if (daysDiff >= 2) return "day";
  else if (daysDiff >= 1) return "hour";
  else return "week";
};

export const getKeyByUnit = (date, unit) => {
  switch (unit) {
    case "quarter":
      return format(startOfQuarter(date), "yyyy-MM-dd");
    case "month":
      return format(startOfMonth(date), "yyyy-MM-dd");
    case "week":
      return format(startOfWeek(date), "yyyy-MM-dd");
    case "day":
      return format(date, "yyyy-MM-dd");
    case "hour":
      return format(date, "yyyy-MM-dd HH");
    case "minute":
      return format(date, "yyyy-MM-dd HH:mm");
    default:
      return format(date, "yyyy-MM-dd");
  }
};

// Generate a range of color shades from darker to lighter
export const adjustColorRange = (
  baseColor,
  darkerCount = 5,
  lighterCount = 5,
) => {
  const hex = baseColor.replace("#", "");

  // Parse base color RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const colors = [];
  const toHex = (c) => {
    const hex = Math.round(c).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  // Generate darker shades (mix with black)
  for (let i = darkerCount; i > 0; i--) {
    const ratio = i / (darkerCount + 1);
    const mixRatio = ratio * 0.3; // Scale to 70% max darkness

    const newR = Math.round(r * (1 - mixRatio));
    const newG = Math.round(g * (1 - mixRatio));
    const newB = Math.round(b * (1 - mixRatio));

    colors.push(`#${toHex(newR)}${toHex(newG)}${toHex(newB)}`);
  }

  // Add base color
  colors.push(baseColor);

  // Generate lighter shades (mix with white)
  for (let i = 1; i <= lighterCount; i++) {
    const ratio = i / (lighterCount + 1);
    const mixRatio = ratio * 0.5;

    const newR = Math.round(r + (255 - r) * mixRatio);
    const newG = Math.round(g + (255 - g) * mixRatio);
    const newB = Math.round(b + (255 - b) * mixRatio);

    colors.push(`#${toHex(newR)}${toHex(newG)}${toHex(newB)}`);
  }

  return colors;
};
